import { useCallback } from "react"
import { readContract } from "@wagmi/core"
import { useConfig } from "wagmi"

import { ONE_SECOND_IN_MILLISECONDS } from "#/shared/constants"
import { Router } from "#/shared/constants/artifacts"
import { SwapRoute } from "#/shared/types"

const refetchInterval = ONE_SECOND_IN_MILLISECONDS * 10 // 10 seconds

const useSwapAmountsOut = () => {
  const config = useConfig()

  const getAmountsOut = useCallback(
    async (amount: bigint, routes: SwapRoute[]) => {
      // @ts-expect-error Figure out why types don't match
      const result = await readContract(config, {
        abi: Router.abi,
        address: Router.address,
        functionName: "getAmountsOut",
        args: [amount, routes],
        query: {
          enabled: !!amount && !!routes.length,
          refetchInterval,
          staleTime: refetchInterval,
        },
      })

      return result as [bigint, bigint]
    },
    [config],
  )

  return { getAmountsOut }
}

export default useSwapAmountsOut
